import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import '../../css/Member.css';

export default function Sanctions() {
  const [userData, setUserData] = useState<any>({});
  const [convertUser, setConvertUser] = useState<any>({});
  const location = useLocation();
  useEffect(() => {
    if (location.state) {
      setUserData(location.state.userData);
    }
  }, [location]);

  useEffect(() => {
    if (userData) {
      const userNew = userData;
      if (Object.keys(userNew).length !== 0) {
        const utcStartDate = new Date(userData?.currentUserBlock?.startDate);
        const kstOffset = 9 * 60;
        const kstStratDate = new Date(utcStartDate.getTime() + kstOffset * 60 * 1000);
        const year = kstStratDate.getFullYear();
        const month = String(kstStratDate.getMonth() + 1); // 월은 0부터 시작하므로 1을 더해줌
        const day = String(kstStratDate.getDate());
        userNew.currentUserBlock.startDate = `${year}. ${month}. ${day}`;
        const utcEndDate = new Date(userData?.currentUserBlock?.endDate);
        const kstEndOffset = 9 * 60;
        const kstEndDate = new Date(utcEndDate.getTime() + kstEndOffset * 60 * 1000);
        const endyear = kstEndDate.getFullYear();
        const endmonth = String(kstEndDate.getMonth() + 1); // 월은 0부터 시작하므로 1을 더해줌
        const endday = String(kstEndDate.getDate());
        userNew.currentUserBlock.endDate = `${endyear}. ${endmonth}. ${endday}`;
        if (userData?.currentUserBlock?.userBlocks?.length !== 0) {
          const utcStartDate = new Date(userData?.currentUserBlock?.userBlocks?.startDate);
          const kstOffset = 9 * 60;
          const kstStratDate = new Date(utcStartDate.getTime() + kstOffset * 60 * 1000);
          const year = kstStratDate.getFullYear();
          const month = String(kstStratDate.getMonth() + 1); // 월은 0부터 시작하므로 1을 더해줌
          const day = String(kstStratDate.getDate());
          userData.currentUserBlock.userBlocks.startDate = `${year}. ${month}. ${day}`;
        }
        setConvertUser(userNew);
      }
    }
  }, [userData]);
  return (
    <>
      <div>
        <div className="contents_wrap">
          <div className="sanctions_wrap">
            <div className="tit_box">
              <h1>
                어바웃피싱 이용이 <br />
                제한되었습니다.
              </h1>
              <p>
                회원님은 아래의 사유로 <br />
                서비스 이용이 제한됩니다.
              </p>
            </div>
            <div className="noti_box">
              <dl>
                <dt>제한 일자</dt>
                <dd>: {convertUser.currentUserBlock?.startDate}</dd>
              </dl>
              <dl>
                <dt>제한 사유</dt>
                <dd>: {userData?.currentUserBlock?.reason}</dd>
              </dl>
              <dl>
                <dt>제한 기간</dt>
                <dd>: {userData?.currentUserBlock?.title}</dd>
              </dl>
              <dl>
                <dt>해제 일시</dt>
                <dd>: {convertUser.currentUserBlock?.endDate}</dd>
              </dl>
            </div>
            <div className="history_box">
              <div className="inner_box">
                <em>이의 신청을 원하실 경우 cs@aboutfishing.kr로 메일을 보내주시기 바랍니다.</em>
                <strong>
                  제재 이력(
                  {convertUser?.currentUserBlock?.userBlocks ? 0 : convertUser?.currentUserBlock?.userBlocks?.length}
                  건)
                </strong>
              </div>
              <div className="x_scroll">
                {convertUser.currentUserBlock?.userBlocks?.map((el: any) => {
                  return (
                    <div className="item">
                      <div className="f_box">
                        <b>{el.reason}</b>
                        <span>{el.restriction}</span>
                      </div>
                      <p>{el.startDate}</p>
                    </div>
                  );
                })}
              </div>
            </div>
            <div className="sanctionsBtn">
              <Link to="/">홈으로 돌아가기</Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
